import { createFileRoute } from "@tanstack/react-router";
import { PortalActionCenterV2Page } from "@/components/v2/pages/portal-action-center-v2-page";

export const Route = createFileRoute("/portal/action-center")({
  component: PortalActionCenterV2Page,
});
